import { render, staticRenderFns } from "./DeleteTOTPDeviceForm.vue?vue&type=template&id=3680b1bc&"
import script from "./DeleteTOTPDeviceForm.vue?vue&type=script&lang=js&"
export * from "./DeleteTOTPDeviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports